import { createVegaChart, createDualAxisChart } from "./vega_chart_helpers";

$(document).on('turbolinks:load', function() {

  // Check for dual axis chart container first
  if($('.dual-axis-chart-container').length > 0) {
    initializeDualAxisChart();
  }

  let container_id = ".lineChart";

  if($(container_id).length != 0) {
    var breakdownAttribute = $(container_id).data()["breakdownAttribute"]
    var ajaxResponseData = eval($(container_id).data("graphService"));
    var labelkey = $(container_id).data()["labelKey"]
  }

  let labels = {
    engagement: "Engagement",
    mentions: "Total Posts",
    likes_count: "Total Likes",
    views_count: "Total Views",
    comments_count: "Total Comments",
    shares_count: "Total Shares",
  }

  var chartLayout = '';
  var chartScale = '';
  var hidePoint = false;
  var tooltipType = 'multiTooltip';

  if(ajaxResponseData) createVegaChart(container_id, labelkey, ajaxResponseData, breakdownAttribute, chartLayout, hidePoint, chartScale)

  $("input[name=chart-type]").on("click", function(event) {
    var parent = $("input[name=chart-type]").parent()
    parent.removeClass("active")
    $(this).parent().addClass("active")
    chartLayout = event.target.value

    const params = new URLSearchParams(window.location.search)
    params.set("chart_type", event.target.value)
    let path = window.location.href.split("?")[0]
    window.history.replaceState(null,null, `${path}?${params}`)
    createVegaChart(container_id, labelkey, ajaxResponseData, breakdownAttribute, chartLayout, hidePoint, chartScale)

  });

  $("input[name=chart-scale]").on("click", function(event) {
    var parent = $("input[name=chart-scale]").parent()
    parent.removeClass("active")
    $(this).parent().addClass("active")
    chartScale = event.target.value

    const params = new URLSearchParams(window.location.search)
    params.set("chart_scale", event.target.value)
    let path = window.location.href.split("?")[0]
    window.history.replaceState(null,null, `${path}?${params}`)
    createVegaChart(container_id, labelkey, ajaxResponseData, breakdownAttribute, chartLayout, hidePoint, chartScale)

  });

  $("input[name=hidePoints]").on("click", function(event) {
    const params = new URLSearchParams(window.location.search)
    if ($(this).is(":checked")){
      $(this).parent().addClass("active")
      hidePoint = $(this).is(":checked")
      params.set("hide_points", true)
    } else {
      hidePoint = $(this).is(":checked")
      $(this).parent().removeClass("active")
      params.set("hide_points", false)
    }

    let path = window.location.href.split("?")[0]
    window.history.replaceState(null,null, `${path}?${params}`)
    createVegaChart(container_id, labelkey, ajaxResponseData, breakdownAttribute, chartLayout, hidePoint, chartScale)
  })

  if (window.location.search.includes("hide_points=true")) {
    $("#hidePoints").parent().addClass("active")
  }

  function initializeDualAxisChart() {
    const container = $('.dual-axis-chart-container');
    const seriesDivs = container.find('.series');
    
    if (seriesDivs.length === 0) {
      console.warn('No series found in dual-axis-chart-container');
      return;
    }
    
    // Get axis parameters from the container
    const axisParams = container.data('axis-params');
    const seriesData = [];
    
    seriesDivs.each(function() {
      const $div = $(this);
      const graphService = $div.data('graph-service');
      const breakdownAttribute = $div.data('breakdown-attribute');
      const labelKey = $div.data('label-key');
      
      if (graphService && breakdownAttribute && labelKey) {
        let axisAssignment = null
        
        if (labelKey === axisParams.secondary) {
          axisAssignment = 'secondary';
        } else if (labelKey === axisParams.primary) {
          axisAssignment = 'primary';
        }
        
        seriesData.push({
          graphService: JSON.stringify(graphService),
          breakdownAttribute: breakdownAttribute,
          labelKey: labelKey,
          searchBy: labelKey,
          axisAssignment: axisAssignment
        });
      }
    });
    
    if (seriesData.length > 0) {
      createDualAxisChart('.dual-axis-chart', seriesData, axisParams);
    } else {
      console.warn('No valid series data found for dual axis chart');
    }
  }
})

// chart with labels

// $(document).on('turbolinks:load', function() {
//   let url = new URL(window.location.href)
//   var breakdownAttribute = $(".lineChart").data()["breakdownAttribute"]
//   var ajaxResponseData = eval($(".lineChart").data("graphService"));
//   var labelkey = $(".lineChart").data()["labelKey"]
//   let labels = {
//     engagement: "Engagement",
//     mentions: "Total Posts",
//     likes_count: "Total Likes",
//     views_count: "Total Views",
//     comments_count: "Total Comments",
//     shares_count: "Total Shares",
//   }
//   var chartLayout = '';
//   var chartScale = '';
//   var hidePoint = false;
//   var tooltipType = 'multiTooltip'
//   createVegaChart()
//   function createVegaChart() {
//     if (ajaxResponseData) {
//       vegaEmbed('.lineChart', {
//         width: "container",
//         height: "container",
//         autosize: "fit",
//         data: { values: ajaxResponseData },
//         layer: [{
//           encoding: {
//             x: {field: "x", type: "temporal", title: "Time"},
//             y: logarithmicChartLayout(),
//             color: {field: "c", type: "nominal", title: breakdownAttribute}
//           },
//           layer: [
//             changeChartLayout(),
//             {
//               params: [{
//                 name: "label",
//                 select: {
//                   type: "point",
//                   encodings: ["x"],
//                   nearest: true,
//                   on: "mouseover",
//                   clear: "mouseout"
//                 }
//               }],
//               mark: "point",
//               encoding: {
//                 opacity: {
//                   condition: {
//                     param: "label",
//                     empty: hidePoints(),
//                     value: 1
//                   },
//                   value: 0
//                 }
//               }
//             }
//           ]
//         },
//         {
//           transform: [
//             {filter: {param: "label", empty: false}},
//             {calculate: "datum.c + ': ' + format(datum.y, '.2s')", as: "annotated_yield"}
//           ],
//           layer: [
//             {
//               mark: {type: "rule", color: "white"},
//               encoding: {
//                 x: {type: "temporal", field: "x", aggregate: "min"}
//               }
//             },
//             {
//               encoding: {
//                 text: {field: "annotated_yield"},
//                 x: {type: "temporal", field: "x"},
//                 y: {type: "quantitative", field: "y"}
//               },
//               layer: [
//                 {
//                   mark: {
//                     type: "text",
//                     align: "left",
//                     stroke: "white",
//                     strokeWidth: 2,
//                     dx: 5,
//                     dy: -5
//                   }
//                 },
//                 {
//                   mark: {type: "text", align: "left", dx: 5, dy: -5},
//                   encoding: {
//                     color: {type: "nominal", field: "c"}
//                   }
//                 }
//               ]
//             }
//           ]
//         }]
//       })
//       .then(({spec, view}) => {
//         getPointData(spec, view);
//       });
//     }
//   }
//   function changeChartLayout() {
//     if (chartLayout == 'bar' || window.location.search.includes("bar")) {
//       return {mark: {type: "bar", width: {band: 0.92}}}
//     } else if (chartLayout == "area" || window.location.search.includes("area")) {
//       return {mark: "area"}
//     } else {
//       return {mark: "line"}
//     }
//   }

//   function tooltipdata(){
//     let tooltipDataArray = []
//     for (var i = 0; i < ajaxResponseData.length; i++) {
//       tooltipDataArray.push({field: "x", "type": "temporal", title: "Time", format: "%b %d, %Y %H:%M" })
//       tooltipDataArray.push({field: `${ajaxResponseData[i]["c"]}`, "type": "quantitative", format: ".2s"})
//     }
//     return tooltipDataArray
//   };
//   function hidePoints() {
//     if (hidePoint == true || window.location.search.includes("hide_points=true")) {
//       return true
//     } else {
//       return false
//     }
//   }
//   function getPointData(spec, view) {
//     var prevPoint, nextPoint, fromDate, fromDateString, toDate, toDateString = ''
//     view.addEventListener('dblclick', function (event, item) {
//       for (var i = 0; i < item.datum.mark.items.length; i++) {
//         if (item.datum.mark.items[i].description.split(";")[0] == item.datum.description.split(";")[0]) {
//           prevPoint = item.datum.mark.items[i-1]
//           nextPoint = item.datum.mark.items[i+1]
//         }
//       }
//       if (prevPoint && nextPoint) {
//         fromDate = new Date(prevPoint.datum.x).toISOString()
//         fromDateString = fromDate.substr(0,16)
//         toDate = new Date(nextPoint.datum.x).toISOString()
//         toDateString = toDate.substr(0,16)
//         window.open(`${window.location.origin}/monitoring?published_at_from=${fromDateString}&published_at_to=${toDateString}`, "_blank")
//       } else if ( prevPoint && nextPoint == undefined) {
//         fromDate = new Date(prevPoint.datum.x).toISOString()
//         fromDateString = fromDate.substr(0,16)
//         toDate = new Date(item.datum.datum.x).toISOString()
//         toDateString = toDate.substr(0,16)
//         window.open(`${window.location.origin}/monitoring?published_at_from=${fromDateString}&published_at_to=${toDateString}`, "_blank")
//       } else if (prevPoint == undefined && nextPoint) {
//         fromDate = new Date(item.datum.datum.x).toISOString()
//         fromDateString = fromDate.substr(0,16)
//         toDate = new Date(nextPoint.datum.x).toISOString()
//         toDateString = toDate.substr(0,16)
//         window.open(`${window.location.origin}/monitoring?published_at_from=${fromDateString}&published_at_to=${toDateString}`, "_blank")
//       }
//     })
//   }
//   function logarithmicChartLayout() {
//     if (window.location.search.includes("logarithmic")) {
//       return {field: "y", type: "quantitative", title: labels[labelkey], scale: {type: "log"}, stack: false }
//     } else {
//       return {field: "y", type: "quantitative", title: labels[labelkey] }
//     }
//   }
//   function showLayerForMultiTooltipData() {
//     return [
//       {
//         encoding: {color: {field: 'c', type: "nominal", title: breakdownAttribute }, y: logarithmicChartLayout()},
//         layer: [changeChartLayout(), hidePoints()]
//       },
//       {
//         transform: [{pivot: "c", value: "y", groupby: ["x"]}],
//         mark: "rule",
//         encoding: {opacity: {condition: {value: 0.3, param: "hover", empty: false}, value: 0}, tooltip:
//           tooltipdata()
//         },
//         params: [{
//           name: "hover",
//           select: {
//             type: "point",
//             fields: ["x"],
//             nearest: true,
//             on: "mouseover",
//             clear: "mouseout"
//           }
//         }]
//       }
//     ]
//   }
//   $("input[name=chart-type]").on("click", function(event) {
//     var parent = $("input[name=chart-type]").parent()
//     parent.removeClass("active")
//     $(this).parent().addClass("active")
//     chartLayout = event.target.value
//     const params = new URLSearchParams(window.location.search)
//     params.set("chart_type", event.target.value)
//     window.history.replaceState(null,null, `${window.location.origin}/monitoring?${params}`)
//     createVegaChart()
//   });
//   $("input[name=chart-scale]").on("click", function(event) {
//     var parent = $("input[name=chart-scale]").parent()
//     parent.removeClass("active")
//     $(this).parent().addClass("active")
//     chartScale = event.target.value
//     const params = new URLSearchParams(window.location.search)
//     params.set("chart_scale", event.target.value)
//     window.history.replaceState(null,null, `${window.location.origin}/monitoring?${params}`)
//     createVegaChart()
//   });
//   $("#hidePoints").on("click", function(event) {
//     const params = new URLSearchParams(window.location.search)
//     if ($(this).is(":checked")){
//       $(this).parent().addClass("active")
//       hidePoint = $(this).is(":checked")
//       params.set("hide_points", true)
//     } else {
//       hidePoint = $(this).is(":checked")
//       $(this).parent().removeClass("active")
//       params.set("hide_points", false)
//     }
//     window.history.replaceState(null,null, `${window.location.origin}/monitoring?${params}`)
//     createVegaChart()
//   })
//   if (window.location.search.includes("hide_points=true")) {
//     $("#hidePoints").parent().addClass("active")
//   }
// })
